export default {"src":"/gallery/_next/static/media/solana.cb6267f7.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};